













import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/header/UHeader.vue";
import ResetPassForm from "@/components/forms/ResetPassForm.vue";
import Footer from "@/components/Footer.vue";

@Component({
  components: {
    Header,
    ResetPassForm,
    Footer,
  },
})
export default class UResetPassSet extends Vue {}
